import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F3.css';
import backIcon2 from '../../../Assests/backIcon2.svg'



function Frame3() {
    let [isLoading, setIsLoading] = useState(false)
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, [])

    if (isLoading === true) {
        return (<div className="F2_image"></div>)
    } else {
        return (
            <div className="F3_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F3_entryBox">
                    <div className="F3_paragraph">
                        {language === 'english' ?
                            <p className='F3_paragraphEnglish'>Today, when Saira woke up to go to school, she felt dampness on her bedsheet. When she looked at it, she saw blood stains on the bedsheet. Saira is absolutely horrified. She first thought it must be an injury, but it doesn’t appear so. Saira is scared, confused and also ashamed. Not knowing what she should do, she has locked herself in her room.</p>
                            :
                            <p className='F3_paragraphUrdu'>آج جب سائرا اسکول جانے کے لیےصبح اٹھی تو اس کو اپنا بستر نم محسوس ہوا۔ جب سائرا نے اپنے بستر کی طرف دیکھا تو اس کو خون کے دھبے نظر آئے۔ سائرا ایک دم سے گھبرا گئی، اس نے پہلے سوچا کہ شاید اس کو چوٹ لگی ہے، لیکن ایسا نہیں تھا۔ سائرا نہ صرف ڈری ہوئی ہے بلکہ شرم اور الجھن کا شکار ہے، اس کو نہیں معلوم کہ اسے اگے کیا کرنا چاہیے اور اس وجہ سے اس نے اپنے آپ کو کمرے میں بند کر لیا ہے۔</p>
                        }
                    </div>
                    <div className="F3_timeline">
                        <div className='F3_timelineBar'>
                            <div className='F3_timelineFill'></div>
                            <span className='F3_timelineText'>3/16</span>
                        </div>
                    </div>

                    <div className="F3_nextFrames">
                        <div className="F3_nextFrame1"></div>
                        <div className="F3_nextFrame2"></div>
                        <div className="F3_nextFrame3"></div>
                    </div>

                    <div className='F3_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(3)) }} className='F3_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame3;